import React from 'react';

const styles = {
    devContainer: {
        display: 'none', // uncomment this to enable
        background: '#fff',
        borderRadius: 5,
        borderLeft: '3px solid #C62828',
        color: '#444',
        padding: '12.5px',
        boxShadow: '0 5px 10px rgba(0,0,0,0.2)',
        margin: '0 0 20px 0',
    },
    devHeading: {
        fontSize: 10,
        fontWeight: 'bold',
        color: '#000',
    },
    devFootNotes: {
        fontSize: 10,
        color: '#aaa',
        textAlign: 'right',
    },
    textBox: {
        fontFamily: 'Helvetica Neue LT W05_55 Roman',
        fontSize: 14,
        lineHeight: '1.7',
        marginTop: 10,
    },
};

function DevWarning(props) {
    return (
        <React.Fragment>
            <div style={styles.devContainer}>
                <div className='row'>
                    <div className='col-xs-6'>
                        <div style={styles.devHeading}>DEV NOTES:</div>
                    </div>
                    <div className='col-xs-6'>
                        <div style={styles.devFootNotes}>
                            This developer notes will not be visible on
                            production.
                        </div>
                    </div>
                </div>
                <div style={styles.textBox}>{props.children}</div>
            </div>
        </React.Fragment>
    );
}

export default DevWarning;
